const preventEKeyInputNumber = event => {
    if (event.keyCode === 69) {
        // Tecla e
        event.preventDefault();
    }
};

export default { preventEKeyInputNumber };
